import { useParams } from "react-router-dom";

import { MODAL_ROUTES, useNavigateModal } from "~/router";
import { TIMEZONES } from "~/screens/Scheduling/InitialVisit/utils/date-time-utils";
import { Appointment } from "~/services";
import { dateToUsFormat } from "~/shared/utils";

/**
 * The date of a cancelled visit opens the edit modal. Gated on the `cancellation` object
 * rather than on the status string: the API only attaches it to history rows that have a
 * local cancellation record, and without one there is nothing to edit and the endpoint would
 * answer 404. A visit cancelled only in the EHR therefore stays plain text.
 */
export const VisitHistoryDateCell = ({ visit }: { visit: Appointment }) => {
  const params = useParams<{ userId: string }>();
  const navigateModal = useNavigateModal();

  const formattedDate = dateToUsFormat(visit.date, TIMEZONES.ET.code);

  if (!visit.cancellation || !params.userId) {
    return formattedDate;
  }

  return (
    <button
      type="button"
      className="text-violet hover:text-violet80 text-left underline"
      onClick={() =>
        navigateModal(
          `${MODAL_ROUTES.editCancellation}/${params.userId}/${visit.id}`,
        )
      }
    >
      {formattedDate}
    </button>
  );
};
